import { Action, ErrorCodes, OperationType } from "puzzle";

export const downloadFiles: Action = [{
  name: 'downloadToaster',
  type: OperationType.action
}, {
  name: 'downloadFilesDownloadAction',
  type: OperationType.action
}];

// @ts-ignore
export const downloadFilesDownloadAction: Action = [{
  ping: {
    template: {
      method: 'post',
      bind: {
        url: '"/jobPhases/" + {submissionData.taskId} + "/download"'
      }
    }
  },
  pingBreakCondition: ['errors'],
  pingCondition: 'processingFinished',
  delay: 1000,
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  pingErrorOperations: [{
    data: {
      template: {
        endpointPrefix: 'DOWNLOAD_',
        responseData: {
          response: {
            bind: {
              data: '{pingResponseDownloadData}',
              status: '{responseStatus}'
            }
          }
        }
      }
    },
    name: 'handleRequestException',
    type: OperationType.action
  }],
  afterDownloadOperations: [{
    condition: '{afterDownloadAction}',
    conditionOperations: [{
      evaluate: true,
      name: '{afterDownloadAction}',
      type: OperationType.action
    }],
    elseOperations: [{
      name: 'refreshMainGrid',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }, {
    persistent: [
      'confirmActionName',
      'submissionData',
      'params'
    ],
    type: OperationType.removePersistentData
  }],
  mappingName: 'pingResponseDownloadData',
  download: {
    template: {
      method: 'get',
      bind: {
        url: "'/jobPhases/download/' + {pingResponseDownloadData.downloadId}",
      }
    }
  },
  withIndicator: false,
  pingOperations: [],
  type: OperationType.pingDownload
}];

export const job_phase_upload: Action = [{
  data: {
    template: {
      completeActionName: 'reportDialogCompleteAllVendor',
      returnActionName: 'reportDialogReturnAllVendor',
      supplierView: true,
      uploadDialogUrl: '/jobPhases/upload',
      uploadReportGetUrl: '/jobPhases/upload/report/',
      downloadReportUrl: '/jobPhases/download/upload/report'
    }
  },
  persistent: ['files', 'uploadDialogUrl', 'uploadReportGetUrl', 'downloadReportUrl', 'completeActionName', 'returnActionName'],
  type: OperationType.addPersistentData
}, {
  name: 'openUploadDialog',
  type: OperationType.action
}];